<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100"
      >
        <div
          class="md-layout"
          v-if="groupServices.includes('pipescanner-inspections')"
        >
          <div class="md-card md-theme-default">
            <div class="md-card-header">
              <h4 class="title">
                {{ $t("dashboard.open_uploads.title") }}
              </h4>
              <p class="category">
                {{ $t("dashboard.open_uploads.subtitle") }}
              </p>
            </div>

            <div class="md-card-content">
              <md-progress-spinner
                md-mode="indeterminate"
                v-if="openUploadsWidget.dataLoading"
              ></md-progress-spinner>
              <div v-if="openUploadsWidget.data">
                <md-table
                  v-model="
                    openUploadsWidget.data[
                      groupSelected + '-pipescanner-inspections'
                    ]
                  "
                  md-sort="inspection_date"
                  md-sort-order="asc"
                >
                  <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell
                      :md-label="$t('dashboard.open_uploads.table_header.date')"
                      md-sort-by="inspection_date"
                      ><strong>{{
                        item.inspection_date
                      }}</strong></md-table-cell
                    >
                    <md-table-cell md-label="ID" md-sort-by="tag">{{
                      item.tag
                    }}</md-table-cell>
                    <md-table-cell :md-label="$t('dashboard.open_uploads.table_header.user')" md-sort-by="user">{{
                      item.user
                    }}</md-table-cell>
                    <md-table-cell :md-label="$t('dashboard.open_uploads.table_header.address')" md-sort-by="address">{{
                      item.address
                    }}</md-table-cell>
                    <md-table-cell :md-label="$t('dashboard.open_uploads.table_header.material')" md-sort-by="material">{{
                      item.material
                    }}</md-table-cell>
                    <md-table-cell :md-label="$t('dashboard.open_uploads.table_header.reason')" md-sort-by="reason">{{
                      item.reason
                    }}</md-table-cell>
                    <md-table-cell
                      md-label="Actie"
                      v-if="permissions.includes('edit:upload')"
                      ><md-button class="md-primary" @click="edit(item.id)"
                        >Edit</md-button
                      ></md-table-cell
                    >
                  </md-table-row>
                </md-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import axios from "axios";

require("mapbox-gl/src/css/mapbox-gl.css");
export default {
  beforeCreate() {},
  components: {},
  data() {
    return {
      openUploadsWidget: {
        dataLoading: false,
        data: null,
      },
    };
  },
  mounted() {
    //check if pipescanner is a service for this group
    if (!this.groupServices.includes("pipescanner-inspections")) {
      this.$router.push("/");
    } else {
      if (!this.openUploadsData){
        this.popuplate_open_uploads_widget();
      } else {
        this.openUploadsWidget = this.openUploadsData;
      }
    }
  },
  computed: {
    ...mapState([
      "apiEndpoints",
      "groupServices",
      "groupSelected",
      "permissions",
      "openUploadsData"
    ]),
  },
  watch: {
    /**
     * watcher to check the validity of route compared to services of group
     * @param {Array} newVal - New value of group services
     */
    groupServices(newVal) {
      if (!newVal.includes("pipescanner-inspections")) {
        this.$router.push("/");
      }
    },
  },
  methods: {
    ...mapMutations(["SET_SELECTED_EDIT", "SET_DATA_OPEN_UPLOADS"]),
    /**
     * Functino for editing of a pipescanner inspection (redirect to another page)
     * @param {string} id - (uu)id of an inspection
     */
    edit(id) {
      this.SET_SELECTED_EDIT(id);
      this.$router.push("/pipescanner-edit");
    },
    /**
     * function to populate the open uploads widget
     */
    async popuplate_open_uploads_widget() {
      this.openUploadsWidget.dataLoading = true;
      //define the query
      var query = {
        query:
          "SELECT c.id, c.tag, c.user, c.address, c.material, c.reason, c.inspection_date FROM c WHERE NOT IS_DEFINED(c.results) AND IS_DEFINED(c.tag)",
      };
      //get token
      var token = await this.$auth.getTokenSilently();
      var header = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      //construct endpoint
      var endpoint =
        this.apiEndpoints.base + this.apiEndpoints.pipescanner.custom;

      //make request
      axios
        .post(endpoint, query, header)
        .then((response) => {
          this.openUploadsWidget.data = response.data;
          this.openUploadsWidget.dataLoading = false;
          this.SET_DATA_OPEN_UPLOADS(this.openUploadsWidget);
          //console.log(
          //  response.data[this.groupSelected + "-pipescanner-inspections"]
          //);
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
  },
};
</script>
